import React, { useEffect, useState, useCallback, useMemo } from "react";

import { Link, useHistory } from "react-router-dom";

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Input,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import BreadCrumb from "../../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";

//Import actions
import {
  getJobsData,
  getCustomersListData,
  getTasksCrmITList,
  getTaskCrmIT,
  updateTaskCrmIT,
  getTaskStatusListCrmIT,
  deleteTaskCrmIT,
  getTaskPriorityList,
  getTaskTypeList,
  deleteTaskCrmITSuccess,
  updateTaskCrmITSuccess,
  getStaffList,
  getTaskCrmITSuccess,
  searchTaskList,
  getTaskTemplateData,
  deleteTaskTemplate,
  deleteTaskTemplateSuccess,
  updateTaskTemplate,
} from "../../../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../../../Components/Common/TableContainer";
import DeleteModal from "../../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CreateEditTaskPopUp from "../../../../../Components/popUpComponents/CreateEditTask/CreateEditTaskPopUp";
import classnames from "classnames";
import LoadingSpinner from "../../../../../Components/Common/Spinner";
import HandleDateTime from "../../../../../Components/Common/HandleDateTime";
import BadgeSelect from "../../../../../Components/Common/BadgeSelect/BadgeSelect";
import StaffSelect from "../../../../../Components/Common/StaffSelect/StaffSelect";
import filterActiveStaff from "../../../../../Components/Common/staffActive";
import LocalDataSearch from "../../../../../Components/SearchAndFilter";
import { getTaskTemplateList } from "../../../../../store/tasksCrmIT/action";

const TaskTemplate = ({ page, vehicle_Id, Opportunity_Id }) => {
  const history = useHistory();
  //variable setup
  // jobs data:

  // data load completed

  // search on jobs data:
  const [searchResults, setSearchResults] = useState([]);
  //Jobs search query:
  const [searchQuery, setSearchQuery] = useState("");

  // can be added to the loader screen if getting stuttered search result to add spinning // not needed if fast
  const [searchInActionShowLoading, setSearchInActionShowLoading] =
    useState(false);
  //  search searchQuery available property names can be added more or less:
  const [allowedSearchFilters, setAllowedSearchFilters] = useState([
    "Title",
    "Staff_FullName",
    "Customer_FullName",
    "Id",
  ]);
  // filter data:
  const allowedFiltersInit = [
    {
      useThisFilter: true,
      filterTitle: "Created Date Range",
      filterType: "DateRange",
      filterProperty: "CreatedDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Due Date Range",
      filterType: "DateRange",
      filterProperty: "DueDateTime",
      filterValue: {
        startDate: "",
        endDate: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Customer",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "Customer_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Staff",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "Staff_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Task Status",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "TaskStatus_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Task Type",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "TaskType_Id",
      filterValue: {
        Id: "",
      },
    },
    {
      useThisFilter: true,
      filterTitle: "Task Priority",
      filterType: "Select",
      filterOptions: [],
      filterProperty: "TaskPriority_Id",
      filterValue: {
        Id: "",
      },
    },
  ];

  const [allowedFilters, setAllowedFilters] = useState(allowedFiltersInit);
  // set of variables for start date end date for flatpickr:

  const [localUpdateTask, setLocalUpdateTask] = useState(false);
  // on add new jobs data set to turn on and off the modal:

  const [updateHappened, setUpdateHappened] = useState(false);

  // MASS UPDATE VARIABLES
  const [jobStatus, setJobStatus] = useState("");

  const [tasksCrmITStatusList, setTasksCrmITStatusList] = useState([]);
  // Staff members

  const [isTypeTab, setIsTypeTab] = useState("all");

  const dispatch = useDispatch();

  const { taskTemplateListAPI } = useSelector((state) => ({
    taskTemplateListAPI: state.TasksCrmIt?.taskTemplateList?.tasktemplate_list,
  }));

  // get filters data from state
  const { customersList } = useSelector((state) => ({
    customersList: state.Customers?.customersDataList?.customer_list,
  }));

  const { filtersData } = useSelector((state) => ({
    filtersData: state.Filters.filtersData,
  }));

  // get staff members data from state
  const { staffData } = useSelector((state) => ({
    staffData: state.Staff.staffList?.staff_list,
  }));

  const {
    tasksCrmITList,
    taskCrmIT,
    taskTemplateData,
    taskTemplateDataLoading,
  } = useSelector((state) => ({
    tasksCrmITList: state.TasksCrmIt.tasksCrmITList?.task_list,
    taskCrmIT: state.TasksCrmIt.taskCrmIT?.task_data,
    taskTemplateData: state.TasksCrmIt.taskTemplateData?.tasktemplate_data,
    taskTemplateDataLoading: state.TasksCrmIt.taskTemplateDataLoading,
  }));
  const { tasksCrmITListLoadingAPI } = useSelector((state) => ({
    tasksCrmITListLoadingAPI: state.TasksCrmIt.tasksCrmITListLoading,
  }));

  const { taskPriorityList, taskTypeList, tasksCrmITStatusListApi } =
    useSelector((state) => ({
      taskPriorityList: state.TasksCrmIt.taskPriorityList?.taskpriority_list,
      taskTypeList: state.TasksCrmIt.taskTypeList?.tasktype_list,
      tasksCrmITStatusListApi:
        state.TasksCrmIt.taskStatusListCrmIT?.taskstatus_list,
    }));
  // load customer data to filter
  useEffect(() => {
    if (isEmpty(customersList)) return;
    setAllowedFilters((prevState) => {
      const newState = [...prevState];
      newState.map((item) => {
        if (item.filterTitle === "Customer") {
          item.filterOptions = customersList.map((item) => {
            return {
              label: item.FullName,
              value: item.Id,
              id: item.Id,
            };
          });
        }
      });
      return newState;
    });
  }, [customersList]);
  // Load staff data to map to filter options
  useEffect(() => {
    if (isEmpty(staffData)) return;
    setAllowedFilters((prevState) => {
      const newState = [...prevState];
      newState.map((item) => {
        if (item.filterTitle === "Staff") {
          item.filterOptions = filterActiveStaff(staffData).map((item) => {
            return {
              label: item.FullName,
              value: item.Id,
              id: item.Id,
            };
          });
        }
      });
      return newState;
    });
  }, [staffData]);
  // Load task status data to map to filter options
  useEffect(() => {
    if (isEmpty(tasksCrmITStatusListApi)) return;
    setAllowedFilters((prevState) => {
      const newState = [...prevState];
      newState.map((item) => {
        if (item.filterTitle === "Task Status") {
          item.filterOptions = tasksCrmITStatusListApi.map((item) => {
            return {
              label: item.Name,
              value: item.Id,
              id: item.Id,
            };
          });
        }
      });
      return newState;
    });
  }, [tasksCrmITStatusListApi]);
  // Load task type data to map to filter options
  useEffect(() => {
    if (isEmpty(taskTypeList)) return;
    setAllowedFilters((prevState) => {
      const newState = [...prevState];
      newState.map((item) => {
        if (item.filterTitle === "Task Type") {
          item.filterOptions = taskTypeList.map((item) => {
            return {
              label: item.Name,
              value: item.Id,
              id: item.Id,
            };
          });
        }
      });
      return newState;
    });
  }, [taskTypeList]);
  // Load task priority data to map to filter options
  useEffect(() => {
    if (isEmpty(taskPriorityList)) return;
    setAllowedFilters((prevState) => {
      const newState = [...prevState];
      newState.map((item) => {
        if (item.filterTitle === "Task Priority") {
          item.filterOptions = taskPriorityList.map((item) => {
            return {
              label: item.Name,
              value: item.Id,
              id: item.Id,
            };
          });
        }
      });
      return newState;
    });
  }, [taskPriorityList]);

  const { jobsList } = useSelector((state) => ({
    jobsList: state.Jobs.jobsData?.job_list,
  }));
  useEffect(() => {
    if (isEmpty(tasksCrmITStatusListApi)) return;
    setTasksCrmITStatusList(
      tasksCrmITStatusListApi?.sort((a, b) => a.Order?.localeCompare(b.Order))
    );
  }, [tasksCrmITStatusListApi]);
  useEffect(() => {
    dispatch(getTaskTemplateList());
    dispatch(getStaffList());
    dispatch(getCustomersListData());
    dispatch(getTaskStatusListCrmIT());
    dispatch(getTaskPriorityList());
    dispatch(getTaskTypeList());
    dispatch(getJobsData());
  }, []);

  const { searchTaskListAPI } = useSelector((state) => ({
    searchTaskListAPI: state.TasksCrmIt.searchTaskList?.task_list,
  }));

  useEffect(() => {
    if (isEmpty(vehicle_Id)) return;
    dispatch(
      searchTaskList([
        {
          task_data: {
            Vehicle_Id: vehicle_Id,
          },
        },
      ])
    );
  }, [vehicle_Id]);

  useEffect(() => {
    if (isEmpty(Opportunity_Id)) return;
    dispatch(
      searchTaskList([
        {
          opportunity_data: { Id: Opportunity_Id },
        },
      ])
    );
  }, [Opportunity_Id]);

  const [isEdit, setIsEdit] = useState(false);
  const [isCreate, setIsCreate] = useState(false);

  const [jobDelete, setJobDelete] = useState([]);

  //delete lead Modal
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [modal, setModal] = useState(false);
  const [modalTask, setModalTask] = useState(false);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTask = useCallback(() => {
    if (modalTask) {
      setModalTask(false);
    } else {
      setModalTask(true);
    }
  }, [modalTask]);

  // Delete Data
  const handleDeleteTask = () => {
    if (jobDelete) {
      dispatch(deleteTaskTemplate(jobDelete));
    }
  };
  const { deleteTaskSuccessAPI } = useSelector((state) => ({
    deleteTaskSuccessAPI: state.TasksCrmIt.deleteTaskTemplateSuccess,
  }));

  useEffect(() => {
    const apiDataStatus = deleteTaskSuccessAPI;
    if (isEmpty(apiDataStatus)) return;
    if (apiDataStatus.status === 200) {
      toast.success(apiDataStatus.message);
      setDeleteModal(false);
      setDeleteModalMulti(false);
      dispatch(getTaskTemplateList());
      //after deleted jobs clear jobDelete array
      setJobDelete([]);
    } else {
      toast.error(apiDataStatus.message);
    }
    dispatch(deleteTaskTemplateSuccess([]));
  }, [deleteTaskSuccessAPI]);

  const onClickDelete = (deleteJob) => {
    // single job delete: set jobDelete to deleteJob
    setJobDelete([deleteJob.Id]);
    setDeleteModal(true);
  };

  // Add Data
  const handleLeadClicks = () => {
    setJobDelete(null);
    setIsEdit(false);
    setIsCreate(false);

    toggleTask();
  };

  // validation job update and create requests go here

  // on submit handle create new jobs list data

  // Update Data
  const handleLeadClick = useCallback(
    (singleJobClick) => {
      dispatch(getTaskTemplateData({ id: singleJobClick.Id }));
      setIsEdit(true);
      setIsCreate(false);

      toggleTask();
    },
    [toggleTask]
  );
  //useEffect set values fo single job update / create

  const handleStaffUpdate = (Staff_Id, Id) => {
    const data = {
      Staff_Id,
      Id,
    };
    dispatch(updateTaskTemplate([data]));
    setLocalUpdateTask(true);
  };
  const handleTaskStatusUpdate = (TaskStatus_Id, Id) => {
    const data = {
      TaskStatus_Id,
      Id,
    };
    dispatch(updateTaskTemplate([data]));
    setLocalUpdateTask(true);
  };
  const handleTaskTypeUpdate = (TaskType_Id, Id) => {
    const data = {
      TaskType_Id,
      Id,
    };
    dispatch(updateTaskTemplate([data]));
    setLocalUpdateTask(true);
  };
  const { updateTaskSuccessAPI } = useSelector((state) => ({
    updateTaskSuccessAPI: state.TasksCrmIt.taskTemplateUpdateSuccess,
  }));

  useEffect(() => {
    const apiDataStatus = updateTaskSuccessAPI;
    if (isEmpty(apiDataStatus)) return;
    if (!localUpdateTask) return;
    if (apiDataStatus.status === 200) {
      toast.success(apiDataStatus.message);
      dispatch(getTaskTemplateList());
    } else {
      toast.error(apiDataStatus.message);
    }

    dispatch(updateTaskCrmITSuccess([]));
    setLocalUpdateTask(false);
  }, [updateTaskSuccessAPI]);
  // Jobs  Column List
  const columns = useMemo(
    () => [
      {
        Header: "Select",
        Cell: (cellProps) => {
          return (
            <input
              key={cellProps.row.original.Id}
              type="checkbox"
              className="leadsCheckBox form-check-input"
              value={cellProps.row.original.Id}
              onChange={() =>
                handleJobListCheckboxChange(cellProps.row.original)
              }
              checked={JSON.stringify(jobDelete).includes(
                cellProps.row.original.Id
              )}
            />
          );
        },
        id: "#",
        accessor: "Id",
        filterable: false,
      },
      {
        // job id  with beginning #Job_Id
        Header: "Id",
        accessor: "Id",
        filterable: false,
        Cell: (task) => (
          <>
            <div className="d-flex align-items-center">
              <div className="flex-grow-1 ms-2 name">
                <Link to={`/tasks/${task.row.original.Id}/view`}>
                  <span className={"like-href"}> #{task.row.original.Id}</span>
                </Link>
              </div>
            </div>
          </>
        ),
      },

      {
        Header: "Task Title",
        accessor: (task) => {
          return (
            <>
              <div>
                <div>
                  <Link to={`/tasks/${task.Id}/view`}>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1 ms-2 name">
                        {task?.Title
                          ? task?.Title.length > 30
                            ? task?.Title.substring(0, 30) + "..."
                            : task?.Title
                          : null}
                      </div>
                    </div>
                  </Link>
                </div>
                <div>
                  {task?.Job_Title ? (
                    <Link to={`/single-job/${task?.Job_Id}`}>
                      <span className="badge badge-soft-primary badge-border">
                        {task?.Job_Title.length > 20
                          ? "#" +
                            task?.Id +
                            " " +
                            task?.Job_Title.substring(0, 20) +
                            "..."
                          : "#" + task?.Id + " " + task?.Job_Title}
                      </span>
                    </Link>
                  ) : null}
                </div>
                {task?.ContactPerson_FullName && (
                  <div
                    title={"Contact Person"}
                    className={"mt-2 badge badge-soft-dark badge-border"}
                  >
                    <span>
                      <i className="fa-solid fa-user-large"></i>{" "}
                    </span>
                    <span className={"fw-semibold"}>
                      {task?.ContactPerson_FullName}
                    </span>
                  </div>
                )}
              </div>
            </>
          );
        },
        filterable: false,
      },

      {
        Header: "Customer",
        accessor: "Customer_Id",
        filterable: true,
        Cell: (task) => (
          <>
            {!isEmpty(task.row.original?.Customer_Id) ? (
              <Link
                to={`/customer-single/${task.row.original?.Customer_Id}/view`}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1 ms-2 name">
                    {task.row.original?.Customer_FullName
                      ? task.row.original?.Customer_FullName.length > 30
                        ? task.row.original?.Customer_FullName.substring(
                            0,
                            30
                          ) + "..."
                        : task.row.original?.Customer_FullName
                      : null}
                  </div>
                </div>
              </Link>
            ) : null}
          </>
        ),
      },

      {
        Header: "Status",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        accessor: (row) => {
          return (
            <BadgeSelect
              current={tasksCrmITStatusList?.find(
                (status) => status.Id === row.TaskStatus_Id
              )}
              list={tasksCrmITStatusList}
              onSelect={(id) => handleTaskStatusUpdate(id, row.Id)}
              placeholder="Search status…"
              emptyLabel="Unassigned"
            />
          );
        },
        filterable: true,
      },
      {
        Header: "Type",
        //accessor status is  joblist.JobStatus_Id jobStatus.ID jobStatus.Name
        accessor: (row) => {
          return (
            <BadgeSelect
              current={taskTypeList?.find(
                (status) => status.Id === row.TaskType_Id
              )}
              list={taskTypeList}
              onSelect={(id) => handleTaskTypeUpdate(id, row.Id)}
              placeholder="Search type…"
              emptyLabel="Unassigned"
            />
          );
        },
        filterable: true,
      },
      {
        Header: "Staff",
        Cell: (task) => {
          //check if row.Staff_Id exists inside staffData.Staff_list.Id

          return (
            <StaffSelect
              current={staffData?.find(
                (item) => item.Id === task.row.original?.Staff_Id
              )}
              list={filterActiveStaff(staffData)}
              onSelect={(id) => handleStaffUpdate(id, task.row.original?.Id)}
              placeholder="Search staff…"
              emptyLabel="Unassigned"
            />
          );
        },
        filterable: false,
      },
      {
        Header: "Due On",
        accessor: "DueDateTime",
        Cell: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return (
            <>
              {row?.row?.original?.DueDateTime &&
                row?.row?.original?.DueDateTime !== "0000-00-00 00:00:00" && (
                  <div>{HandleDateTime(row?.row?.original?.DueDateTime)}</div>
                )}
            </>
          );

          // return row.CreatedDateTime
        },
        filterable: false,
      },
      {
        Header: "Create On",
        accessor: (row) => {
          //CreatedDateTime sort date so its day Month name Year and time

          return <div>{HandleDateTime(row?.CreatedDateTime)}</div>;

          // return row.CreatedDateTime
        },
        filterable: false,
      },
      {
        Header: "Action",
        Cell: (cellProps) => {
          return (
            <UncontrolledDropdown>
              <DropdownToggle
                className="btn btn-soft-info btn-icon fs-14"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="fa-solid fa-ellipsis"></i>
              </DropdownToggle>
              <DropdownMenu>
                <li>
                  <DropdownItem>
                    <div
                      className="edit-item-btn"
                      onClick={() => {
                        handleLeadClick(cellProps.row.original);
                      }}
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-pencil-fill align-center text-muted"></i>
                        <span> Edit</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem>
                    <div
                      className="remove-item-btn"
                      onClick={() => {
                        onClickDelete(cellProps.row.original);
                      }}
                      to="#"
                    >
                      <div className={"job-settings-buttons"}>
                        <i className="ri-delete-bin-fill align-center text-muted"></i>{" "}
                        <span> Delete</span>
                      </div>
                    </div>
                  </DropdownItem>
                </li>
              </DropdownMenu>
            </UncontrolledDropdown>
          );
        },
      },
    ],
    [handleLeadClick, onClickDelete]
  );

  // handle job search

  document.title = "Task List | CRMit - Less Work. Do More.";

  // handle job search

  // handle checkbox change and assign to jobDelete array
  const handleJobListCheckboxChange = (Job) => {
    // check if jobDelete array is object contains Job.Job_Id if not add to array
    if (JSON.stringify(jobDelete).includes(Job.Id)) {
      // if includes remove from array
      // find if Job.Id value exists in jobDelete array
      setJobDelete(jobDelete.filter((item) => item !== Job.Id));
    } else {
      // add to array
      setJobDelete([...jobDelete, Job.Id]);
    }
  };

  // handleMassJobUpdate

  const handleCreateNewJob = () => {
    setIsCreate(true);
    setIsEdit(false);
    dispatch(getTaskCrmITSuccess([]));

    toggle();
    toggleTask();
  };
  const [showFilter, setShowFilter] = useState(false);
  const toggleShowFilter = () => {
    setShowFilter(!showFilter);
  };
  return (
    <React.Fragment>
      <LocalDataSearch
        Page={"TaskListPage"}
        ReceivedDataAPI={taskTemplateListAPI}
        setSearchInActionShowLoading={setSearchInActionShowLoading} //Mandatory* can be on and off for search loading if data heavy page I recommend to use it
        activeSearchTab={isTypeTab}
        // recurringJobListDataAPI={recurringJobListData} // Job Page Spesific
        allowedSearchFilters={allowedSearchFilters}
        searchQuery={searchQuery}
        setSearchFilteredResults={setSearchResults}
        showFilter={showFilter}
        setShowFilter={setShowFilter}
        toggleShowFilter={toggleShowFilter}
        allowedFiltersInit={allowedFiltersInit}
        allowedFilters={allowedFilters}
        setAllowedFilters={setAllowedFilters}
      />

      <div>
        {modalTask && (
          <CreateEditTaskPopUp
            modalTask={modalTask}
            setModalTask={setModalTask}
            toggleTask={toggleTask}
            isCreate={isCreate}
            isEdit={isEdit}
            taskCrmIT={taskCrmIT}
            staffData={staffData}
            customersList={customersList}
            tasksCrmITStatusList={tasksCrmITStatusList}
            taskPriorityList={taskPriorityList}
            taskTypeList={taskTypeList}
            ShowJobList={true}
            TaskList={true}
            jobsList={jobsList}
            Opportunity_Id={Opportunity_Id}
            taskTemplate={true} // sets task to become template instead an actual task with all its properties
          />
        )}

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteTask}
          onCloseClick={() => setDeleteModal(false)}
        />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={handleDeleteTask}
          onCloseClick={() => setDeleteModalMulti(false)}
        />

        <div className={"mt-4"}>
          <Row>
            <Col lg={12}>
              <div id="leadsList">
                {/*<Row className="row align-items-end mt-3">*/}
                {/*  <Col>*/}
                {/*    <div className={"d-flex justify-content-between"}>*/}
                {/*      <div id="mail-filter-navlist">*/}
                {/*        <Nav*/}
                {/*          className="nav nav-tabs nav-tabs-custom nav-primary gap-1 text-center border-bottom-0"*/}
                {/*          role="tablist"*/}
                {/*        >*/}
                {/*          <NavItem>*/}
                {/*            <NavLink*/}
                {/*              className={classnames(*/}
                {/*                { active: isTypeTab === "open" },*/}
                {/*                "fw-semibold"*/}
                {/*              )}*/}
                {/*              onClick={() => {*/}
                {/*                setIsTypeTab("open");*/}
                {/*              }}*/}
                {/*              href="#"*/}
                {/*            >*/}
                {/*              <i className="fa-regular fa-folder-open"></i>*/}
                {/*              <span className="ms-1 d-none d-sm-inline-block">*/}
                {/*                Open*/}
                {/*              </span>*/}
                {/*            </NavLink>*/}
                {/*          </NavItem>*/}
                {/*          <NavItem>*/}
                {/*            <NavLink*/}
                {/*              className={classnames(*/}
                {/*                { active: isTypeTab === "all" },*/}
                {/*                "fw-semibold"*/}
                {/*              )}*/}
                {/*              onClick={() => {*/}
                {/*                setIsTypeTab("all");*/}
                {/*              }}*/}
                {/*              href="#"*/}
                {/*            >*/}
                {/*              <i className="fa-solid fa-layer-group"></i>*/}
                {/*              <span className="ms-1 d-none d-sm-inline-block">*/}
                {/*                All*/}
                {/*              </span>*/}
                {/*            </NavLink>*/}
                {/*          </NavItem>*/}
                {/*        </Nav>*/}
                {/*      </div>*/}
                {/*      <div className={"pe-2"}>*/}
                {/*        <UncontrolledDropdown>*/}
                {/*          <DropdownToggle*/}
                {/*            style={{*/}
                {/*              // background: "none",*/}
                {/*              // color: "black",*/}
                {/*              // border: "solid 1px black",*/}
                {/*              margin: "0px",*/}
                {/*              padding: "0px 3px",*/}
                {/*            }}*/}
                {/*          >*/}
                {/*            <i className="fa-solid fa-gears"></i>*/}
                {/*          </DropdownToggle>*/}
                {/*          <DropdownMenu>*/}
                {/*            <DropdownItem*/}
                {/*              onClick={() => {*/}
                {/*                history.push("/tasks");*/}
                {/*              }}*/}
                {/*            >*/}
                {/*              <i className="fa-solid fa-bars pe-1"></i> Task*/}
                {/*              List*/}
                {/*            </DropdownItem>*/}
                {/*            <DropdownItem*/}
                {/*              onClick={() => {*/}
                {/*                history.push("/weekly-tasks");*/}
                {/*              }}*/}
                {/*            >*/}
                {/*              <i className="fa-solid fa-list-check pe-1"></i>{" "}*/}
                {/*              Weekly Task List*/}
                {/*            </DropdownItem>*/}
                {/*            <DropdownItem*/}
                {/*              onClick={() => {*/}
                {/*                history.push("/weekly-tasks-kanban");*/}
                {/*              }}*/}
                {/*            >*/}
                {/*              <i className="fa-solid fa-sliders pe-1"></i>{" "}*/}
                {/*              Kanban Task List*/}
                {/*            </DropdownItem>*/}
                {/*          </DropdownMenu>*/}
                {/*        </UncontrolledDropdown>*/}
                {/*      </div>*/}
                {/*    </div>*/}
                {/*  </Col>*/}
                {/*</Row>*/}
                <CardHeader className="border-0">
                  <Row className="d-flex align-items-center ">
                    <Col sm={4}>
                      <div className={"task-search-and-delete-box"}>
                        {jobDelete.length > 0 && (
                          <button
                            title={"Delete Selected"}
                            className="btn btn-soft-danger me-2"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            <i className="ri-delete-bin-2-line"></i>
                          </button>
                        )}

                        <div className="search-box">
                          <Input
                            // create search with jobs List Data
                            type="search"
                            className="form-control search"
                            placeholder="Search for..."
                            onChange={(e) => setSearchQuery(e.target.value)}
                            value={searchQuery}
                          />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </div>
                    </Col>
                    <div className="col-sm-auto ms-auto">
                      <div className="hstack gap-2">
                        <button
                          type="button"
                          className="btn btn-info btn-info-filters"
                          onClick={() => toggleShowFilter()}
                        >
                          <i className="ri-filter-3-line align-bottom me-1"></i>{" "}
                          Filters
                        </button>
                        <button
                          type="button"
                          className="btn btn-success add-btn btn-info-add-jobs"
                          id="create-btn"
                          onClick={handleCreateNewJob}
                        >
                          <i className="ri-add-line align-bottom me-1"></i>
                          New Task Template
                        </button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody className="pt-0">
                  <div>
                    {tasksCrmITListLoadingAPI && isEmpty(tasksCrmITList) ? (
                      <LoadingSpinner />
                    ) : (
                      <>
                        {!isEmpty(searchResults) ? (
                          <TableContainer
                            columns={columns}
                            data={searchResults}
                            isGlobalFilter={false}
                            isAddUserList={false}
                            customPageSize={10}
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-0"
                            tableClass="align-middle table-nowrap"
                            theadClass="text-muted"
                            handleLeadClick={handleLeadClicks}
                            isLeadsFilter={false}
                          />
                        ) : (
                          <div>
                            <div className="text-center">
                              <h2> Create your first task.</h2>
                              <p className="text-muted">
                                Tasks are the best way to keep track of your
                                work.
                              </p>

                              <button
                                className="btn btn-success add-btn btn-info-add-jobs"
                                id="create-btn"
                                onClick={handleCreateNewJob}
                              >
                                <i className="ri-add-line align-bottom me-1"></i>
                                New Task Template
                              </button>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </CardBody>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TaskTemplate;
